import { MenuItem } from '@mui/material';
import styled from 'styled-components';

import { StyledSelect as BaseSelect } from 'components/Input/styles';

import { colors } from 'theme/colors';

export const StyledSelect = styled(BaseSelect)`
  appearance: none;
  border: 1px solid ${colors.legacy.grey[400]};
  border-radius: 8px;
  height: 40px;
  outline: none;
  padding: 10px 0;
  font-size: 1.4rem;
  text-align: left;
  line-height: 1.5rem;
  color: ${colors.legacy.secondary[100]};
`;

export const StyledMenuItem = styled(MenuItem)`
  color: ${colors.legacy.grey[200]};
  font-size: 1.3rem;
  line-height: 2rem;
`;
